import sdkFactory from '@gravity-ui/sdk';
import {ExperimentKey, Header as H} from 'common/constants';
import type {SchemaType} from 'common/schema';

import getCookie from './getCookie';

const {
    YC: {sdkEndpoint, csrfToken, experiments, user, lang},
} = window;

export const sdk = sdkFactory<{root: SchemaType}>({
    endpoint: sdkEndpoint,
    csrfToken: csrfToken,
    axiosConfig: {
        headers: {
            ...(lang ? {[H.AcceptLanguage]: lang} : {}),
            ...(experiments[ExperimentKey.Com] || experiments[ExperimentKey.ComForce]
                ? {[H.xUseCollab]: '1'}
                : {}),
            ...(experiments[ExperimentKey.formsYandexUid] && user?.yandexuid
                ? {[H.xFormsYandexUid]: getCookie('yandexuid') ?? user?.yandexuid}
                : {}),
        },
    },
});
